import * as Criteria from "./Criteria/index.js";
import * as Result from "./Result/index.js";
import * as Migrated from "./Migrated/index.js";
import * as Results from "./Results/index.js";
import * as SearchIds from "./SearchIds/index.js";
import * as Surveys from "./Surveys/index.js";
/** CoStar.Api.FusionSearch.ProductType */
export var ProductType;
(function (ProductType) {
    ProductType[ProductType["Public"] = 0] = "Public";
    ProductType[ProductType["Property"] = 1] = "Property";
    ProductType[ProductType["Tenant"] = 2] = "Tenant";
    ProductType[ProductType["Comps"] = 5] = "Comps";
    ProductType[ProductType["ProfessionalDirectory"] = 40] = "ProfessionalDirectory";
    ProductType[ProductType["Suite"] = 41] = "Suite";
    ProductType[ProductType["ForSaleProfessional"] = 47] = "ForSaleProfessional";
    ProductType[ProductType["LeaseComps"] = 63] = "LeaseComps";
    ProductType[ProductType["Go"] = 103] = "Go";
    ProductType[ProductType["LeaseDcf"] = 173] = "LeaseDcf";
})(ProductType || (ProductType = {}));
/** CoStar.Api.FusionSearch.InfoDocTypes */
export var InfoDocTypes;
(function (InfoDocTypes) {
    InfoDocTypes[InfoDocTypes["None"] = 0] = "None";
    InfoDocTypes[InfoDocTypes["HasNote"] = 1] = "HasNote";
    InfoDocTypes[InfoDocTypes["HasFloorPlan"] = 2] = "HasFloorPlan";
    InfoDocTypes[InfoDocTypes["HasVideo"] = 4] = "HasVideo";
    InfoDocTypes[InfoDocTypes["HasPhoto"] = 8] = "HasPhoto";
    InfoDocTypes[InfoDocTypes["HasDocument"] = 16] = "HasDocument";
})(InfoDocTypes || (InfoDocTypes = {}));
/** CoStar.Api.FusionSearch.QueryCategory */
export var QueryCategory;
(function (QueryCategory) {
    QueryCategory[QueryCategory["Unknown"] = 0] = "Unknown";
    QueryCategory[QueryCategory["Search"] = 1] = "Search";
    QueryCategory[QueryCategory["Lookup"] = 2] = "Lookup";
    QueryCategory[QueryCategory["Analytic"] = 3] = "Analytic";
    QueryCategory[QueryCategory["MoveLeads"] = 4] = "MoveLeads";
    QueryCategory[QueryCategory["MoveLeadsLookup"] = 5] = "MoveLeadsLookup";
})(QueryCategory || (QueryCategory = {}));
/** CoStar.Api.FusionSearch.QueryType */
export var QueryType;
(function (QueryType) {
    QueryType[QueryType["None"] = 0] = "None";
    QueryType[QueryType["PropertySearch"] = 1] = "PropertySearch";
    QueryType[QueryType["PropertyLookup"] = 2] = "PropertyLookup";
    QueryType[QueryType["AnalyticSearch"] = 3] = "AnalyticSearch";
    QueryType[QueryType["TenantSearch"] = 15] = "TenantSearch";
    QueryType[QueryType["TenantLookup"] = 16] = "TenantLookup";
    QueryType[QueryType["ExchangeSearch"] = 17] = "ExchangeSearch";
    QueryType[QueryType["ExchangeLookup"] = 18] = "ExchangeLookup";
    QueryType[QueryType["CompsSearch"] = 31] = "CompsSearch";
    QueryType[QueryType["CompsLookup"] = 32] = "CompsLookup";
    QueryType[QueryType["RetailSearch"] = 35] = "RetailSearch";
    QueryType[QueryType["ShoppingCenterSearch"] = 38] = "ShoppingCenterSearch";
    QueryType[QueryType["LeaseCompSearch"] = 40] = "LeaseCompSearch";
    QueryType[QueryType["LeaseCompLookup"] = 41] = "LeaseCompLookup";
    QueryType[QueryType["ForLeaseSearch"] = 50] = "ForLeaseSearch";
    QueryType[QueryType["ForLeaseLookup"] = 51] = "ForLeaseLookup";
    QueryType[QueryType["MultifamilySearch"] = 52] = "MultifamilySearch";
})(QueryType || (QueryType = {}));
export { Criteria, Result, Migrated, Results, SearchIds, Surveys };
